
// Collection menu component
Vue.component('collection-menu', {
  methods: {
    checkTag(tag, event) {
      event.preventDefault();
      // Get copy of collection data from sessionStorage and copy current tags
      let currentCollectionData = JSON.parse(sessionStorage.getItem('collectionData'))
      let currentTags = currentCollectionData.currentTags
      let genders = ['all-gender', 'boy', 'girl', 'women']
      let products = ['all-products', 'tops', 'bottoms', 'one-pieces', 'dresses', 'sleep']

      // Check if another tag of that type already exists in the current tags. If it does, remove it, then push in the new tag
      let checkAndPush = (category) => {
        if(currentTags.length) {
          category.forEach(catTag => {
            currentTags.forEach(i => {
              if(i === catTag) {
                currentTags.splice(currentTags.indexOf(catTag), 1)
              }
            })
          })
        }
        currentTags.push(tag)
      }

      // Check if current tag is gendered
      if(genders.includes(tag)) {
        checkAndPush(genders)
      }

      // Check if current tag is a product type
      if(products.includes(tag)) {
        checkAndPush(products)
      }

      // Push new array of tags into sessionStorage. See method.
      this.pushTags(currentTags)
    },
    pushTags(tagArray) {
      let currentCollectionData = JSON.parse(sessionStorage.getItem('collectionData'))

      // Set the newly built tag array as current in sessionStorage.
      currentCollectionData.currentTags = tagArray
      sessionStorage.setItem('collectionData', JSON.stringify(currentCollectionData))

      // Execute URL update. See method.
      this.goToFilter()
    },
    goToFilter() {
      let currentCollectionData = JSON.parse(sessionStorage.getItem('collectionData'))

      // Builds new URL from current tags.
      let newUrl = `/collections/${currentCollectionData.handle}/${currentCollectionData.currentTags.join('+')}`

      // Redirects user to new filtered URL
      window.location.href = newUrl
    },
    isActive(tag) {
      let currentCollectionData = JSON.parse(sessionStorage.getItem('collectionData'))
      let currentTags = currentCollectionData.currentTags
      return currentTags.includes(tag) ? 'is-active' : ''
    }
  },
  beforeMount() {
    const currentCollectionData = window.eHouse.currentCollectionData
    const newCollectionData = window.eHouse.newCollectionData
    const currentHandle = window.eHouse.handle
    let parsedCollectionData

    const stringify = (json) => JSON.stringify(json)

    // If current collection data exists, parse and make available
    if(currentCollectionData !== null) {
      parsedCollectionData = JSON.parse(currentCollectionData)
    }

    // If there's no data or if we're on a new collection, push the fresh data into sessionStorage
    if(currentCollectionData === null || parsedCollectionData.handle !== currentHandle) {
      console.log('test')
      console.log(stringify(newCollectionData))
      sessionStorage.setItem('collectionData', stringify(newCollectionData))
    }

    // Reset with fresh data if no filters are selected
    if(window.location.href.includes(currentHandle) && !window.location.href.includes(`${currentHandle}/`) && currentCollectionData !== null) {
      sessionStorage.setItem('collectionData', stringify(newCollectionData))
    }
  }
})

Vue.config.devtools = true

new Vue({
  el: '#app'
})